import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 11v-5a1 1 0 0 0 -1 -1h-16a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9","key":"svg-0"}],["path",{"d":"M17 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M10 13v-4h4","key":"svg-2"}],["path",{"d":"M14 13l-4 -4","key":"svg-3"}]]

const IconPinEnd = createReactComponent('outline', 'pin-end', 'PinEnd', __iconNode);

export default IconPinEnd;